export enum ProgressBarStatus {
    Disabled = 'disabled',
    Running = 'running',
    Success = 'success',
    Error = 'error',
}
